import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { HttpFunctionResult } from 'src/app/_interfaces/HttpFunctionResult';
import { CalendarAppointment } from 'src/app/_pages/calendar/AppointmentItem';
import { CalendarEditPopoverPage } from 'src/app/_pages/calendar/calendar-edit-popover/calendar-edit-popover.page';
import { CalendarService } from 'src/app/_provider/calendar/calendar.service';
import { FeedbackService } from 'src/app/_provider/feedback.service';
import { PopoverListItem, PopoverPage } from 'src/app/_template/popover/popover.page';

@Component({
    selector: 'ticket-detail-appointment-item',
    templateUrl: './ticket-detail-appointment-item.component.html',
    styleUrls: ['./ticket-detail-appointment-item.component.scss'],
    standalone: false
})
export class TicketDetailAppointmentItemComponent implements OnInit {

  @Input() public appointment: CalendarAppointment
  @Input() public finished: boolean = false

  @Output() public appointemtChanged: EventEmitter<CalendarAppointment> = new EventEmitter<CalendarAppointment>()
  @Output() public appontmentDeleted: EventEmitter<CalendarAppointment> = new EventEmitter<CalendarAppointment>()

  constructor(
    private feedback: FeedbackService,
    private calendarSrv: CalendarService
  ) { }

  ngOnInit() {}

  public async openOptions(event: Event){
    const list: PopoverListItem[] = [
      {id: 1, description: "Bearbeiten", icon: "fa-pen"},
      {id: 2, description: "Löschen", icon: "fa-trash", danger: true},
    ]

    const result: HttpFunctionResult<PopoverListItem> =  await this.feedback.showPopover({
      event: event,
      component: PopoverPage,
      componentProps: {list}
    })

    if(result.success){
      if(result.data.id == 1) await this.editAppointment()
      else if(result.data.id == 2) await this.deleteAppointment()
    }
  }

  private async editAppointment(){
    await this.feedback.openModal(CalendarEditPopoverPage, {
      isModal: true,
      isNew: false,
      appointment: this.appointment
    }, async (result: HttpFunctionResult<CalendarAppointment>) => {
      if(!result.success) return
      this.appointemtChanged.emit(this.appointment)
      await this.calendarSrv.updateAppointment(result.data)
    })
  }

  private async deleteAppointment(){
    if(!(await this.feedback.confirm(`Möchten Sie den Termin "${this.appointment.subject}" wirklich löschen?`, "Löschen", "Abbrechen"))) return
    this.appontmentDeleted.emit(this.appointment)
    await this.calendarSrv.deleteAppointment(this.appointment)
  }
}
